import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import WebinarRegistrationDateInterface from 'common/types/entities/WebinarRegistrationDateInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { IntervalTypes } from 'common/components/entities/WebinarRegistrationDate/WebinarRegistrationDate'

export function createWebinarRegistrationDate(
  parentId: string,
  masterBlockId?: MasterBlockId,
): WebinarRegistrationDateInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarRegistrationDate,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.WebinarRegistrationDate,
    timeFormat: 24,
    spaceBetween: 20,
    scheduledHours: [],
    interval: IntervalTypes.hour,
  }
}
